export default "__VITE_ASSET__CldEYE5d__"